<ph-card heading="Mark as paid" flat [formGroup]="markAsPaidFormGroup">
    <ph-field>
        <ph-label>How would you like to mark this invoice as paid?</ph-label>
        <ph-radio-group formControlName="paymentRecordType" ngDefaultControl [items]="recordTypeItems"></ph-radio-group>
        <ph-hint has-error *ngIf="potentialTransactionMatches.length === 0">No matches found</ph-hint>
    </ph-field>

    <!-- Mark as Paid Transaction Section -->
    <ng-container
        *ngIf="markAsPaidFormGroup.get('paymentRecordType')?.value === PaymentRecordType.MATCH; else createTransaction">
        <ph-field>
            <ph-label>Select transaction</ph-label>
            <ph-select formControlName="existingTransactionToMatch" ngDefaultControl [items]="transactionItems"
                       placeholder="Select transaction"></ph-select>
            <ph-hint has-error
                *ngIf="markAsPaidFormGroup.get('existingTransactionToMatch').touched &&
              markAsPaidFormGroup.get('existingTransactionToMatch').hasError('required')">
                Please select a transaction
            </ph-hint>
        </ph-field>
    </ng-container>

    <ng-template #createTransaction>
        <ph-field>
            <ph-label>Payment bank account</ph-label>
            <app-bank-account-selector
                [formGroup]="markAsPaidFormGroup"
                controlName="bankAccountForTransaction"
                [accountId]="localPayable?.payableUnifiedBankAccountId"
            >
            </app-bank-account-selector>
            <ph-hint has-error
                *ngIf="markAsPaidFormGroup.get('bankAccountForTransaction').touched &&
              markAsPaidFormGroup.get('bankAccountForTransaction').hasError('required')">
                Bank account is required
            </ph-hint>
        </ph-field>

        <ph-field>
            <ph-label>Payment date</ph-label>
            <ph-date-input formControlName="paymentDate" ngDefaultControl></ph-date-input>
            <ph-hint has-error
                *ngIf="markAsPaidFormGroup.get('paymentDate').touched &&
                markAsPaidFormGroup.get('paymentDate').hasError('required')"
            >
                Payment date is required
            </ph-hint>
        </ph-field>

        <ph-field>
            <ph-label sub="(optional)">Memo</ph-label>
            <ph-textarea formControlName="paymentMemo" ngDefaultControl rows="2"
                         placeholder="Other invoice details"></ph-textarea>
        </ph-field>
    </ng-template>
</ph-card>
